import { render, staticRenderFns } from "./buyCountyProduction.vue?vue&type=template&id=2871535e&scoped=true"
import script from "./buyCountyProduction.vue?vue&type=script&lang=js"
export * from "./buyCountyProduction.vue?vue&type=script&lang=js"
import style0 from "./buyCountyProduction.vue?vue&type=style&index=0&id=2871535e&prod&scoped=true&lang=scss"
import style1 from "./buyCountyProduction.vue?vue&type=style&index=1&id=2871535e&prod&scoped=true&lang=css"
import style2 from "./buyCountyProduction.vue?vue&type=style&index=2&id=2871535e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2871535e",
  null
  
)

export default component.exports